import { CircularProgress, Stack, Typography } from "@mui/material";
import { IIcon } from "../../images/IIcon";
import { CustomButton } from "../../ui/CustomButton";
import { BaseModal } from "../../ui/BaseModal";
import React from "react";

export const SaveModal = ({
  isOpen,
  setIsOpen,
  successHandler,
  isLoading,
  committeeSelected,
  committeeExpected,
  clusterSelected,
  clusterExpected,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  successHandler: () => void;
  isLoading: boolean;
  committeeSelected: number;
  committeeExpected: number;
  clusterSelected: number;
  clusterExpected: number;
}) => {
  const isCommitteeExceeded = committeeSelected > committeeExpected;
  const isClusterExceeded = clusterSelected > clusterExpected;

  return (
    <BaseModal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      title="Save All Changes"
      sx={{ padding: "32px", maxWidth: "368px", width: "90%" }}
    >
      <Stack gap="32px" maxWidth="340px" width="100%">
        <Typography component="span" variant="body1" color="text.secondary">
          Do you want to save changes in the table?
        </Typography>

        {(isCommitteeExceeded || isClusterExceeded) && (
          <Stack direction="row" gap="8px">
            <IIcon />
            <Stack>
              {isCommitteeExceeded && (
                <Typography
                  component="span"
                  variant="body2"
                  color="custom.textDarkBlue"
                >
                  The buying committee exceeded the limit by{" "}
                  {committeeSelected - committeeExpected} on {committeeSelected}
                  /{committeeExpected}
                </Typography>
              )}
              {isClusterExceeded && (
                <Typography
                  component="span"
                  variant="body2"
                  color="custom.textDarkBlue"
                >
                  The buying cluster exceeded the limit by{" "}
                  {clusterSelected - clusterExpected} on {clusterSelected}/
                  {clusterExpected}
                </Typography>
              )}
            </Stack>
          </Stack>
        )}

        <Stack direction="row" gap="8px">
          <CustomButton
            onClick={() => setIsOpen(false)}
            variant="contained"
            textColor="#4C545B"
            fullWidth
            type="button"
            customColor="#F1F1F1"
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={successHandler}
            variant="contained"
            fullWidth
            type="button"
            customColor="#1C3C6C"
            startIcon={
              isLoading && (
                <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
              )
            }
          >
            Save
          </CustomButton>
        </Stack>
      </Stack>
    </BaseModal>
  );
};
